export enum AccountRelationComparison {
  is = 1,
}